exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2AIz3iP_lSLf52GGuWV2Ei{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._2AIz3iP_lSLf52GGuWV2Ei{margin-left:0}html[dir=rtl] ._2AIz3iP_lSLf52GGuWV2Ei{margin-right:0}html[dir] ._34EgyxObAFW7vijZYvTh04:hover{background:transparent}._3YZK7SYgZcQF08Va0Aeoa_{width:0}", ""]);

// exports
exports.locals = {
	"moreLabel": "_2AIz3iP_lSLf52GGuWV2Ei",
	"moreRoot": "_34EgyxObAFW7vijZYvTh04",
	"noIcon": "_3YZK7SYgZcQF08Va0Aeoa_"
};